// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "assets/" + chunkId + "." + {"12": "ccac1178b22fdd2e","241": "8a6e3061375f23b7","352": "b1b164cd3136dbc6","504": "327b1f23f19f8d9a","529": "de9509324338519e","709": "8e756381baadef40","854": "d7e4538fd805010b","90": "946f6546494aa55a","909": "16875c23a118445e","921": "dea86acf110f5ae5","923": "cc90aa52020bf2fa",}[chunkId] + ".bundle.js"
}